import { PUBLIC_URL } from 'utils/constants';

export default {
  COMMUNITY_GROUPS_LIST: `${PUBLIC_URL}/community/groups`,
  COMMUNITY_GROUPS_ADD: `${PUBLIC_URL}/community/groups/add`,
  COMMUNITY_GROUPS_EDIT: `${PUBLIC_URL}/community/groups/edit/:id`,
  COMMUNITY_GROUPS_DETAILS: `${PUBLIC_URL}/community/groups/details/:id`,
  COMMUNITY_REPORTED_POSTS_LIST: `${PUBLIC_URL}/community/reported-posts`,

  COMMUNITY_GROUP_POSTS_ADD: `${PUBLIC_URL}/community/group/:groupId/posts/add`,
  COMMUNITY_GROUP_POSTS_EDIT: `${PUBLIC_URL}/community/group/:groupId/posts/edit/:id`,

  COMMUNITY_MEMBERS_EDIT: `${PUBLIC_URL}/community/members/edit/:id`,

  COMMUNITY_POSTS_LIST: `${PUBLIC_URL}/community/posts`,
  COMMUNITY_POSTS_ADD: `${PUBLIC_URL}/community/post/add`,
  COMMUNITY_POSTS_EDIT: `${PUBLIC_URL}/community/posts/edit/:id`,

  COMMUNITY_COMMENTS_LIST: `${PUBLIC_URL}/community/comments`,
  COMMUNITY_BLOCKED_USERS_LIST: `${PUBLIC_URL}/community/blocked-users`,

  COMMUNITY_GROUP_POSTS_ADD: `${PUBLIC_URL}/community/group/:groupId/posts/add`,
  COMMUNITY_GROUP_POSTS_EDIT: `${PUBLIC_URL}/community/group/:groupId/posts/edit/:id`,

  COMMUNITY_POST_DETAILS: `${PUBLIC_URL}/community/post/details/:id`,
};
